<template>
  <div style="background-color: #94070a;" class="sidebar dinline-block vtop bg-red tcenter">
    <div class="st fs24 twhite">栏目导航</div>
    <div class="alist br8">
      <div class="adiv bgw">
        <template v-for="(item,index) in $params.enrollColumn">
          <router-link v-if="item.type==1" :to="{path:item.to,query:{pid:index,category_id:item.params.category_id}}" class="sa fs18 dblock" :class="{active:index==$route.query.pid}">{{item.name}}</router-link>
          <template v-else-if="item.type==2">
            <div class="sa hsa fs18 cpointer up-down-div" :data-key = "index" :class="{active:index==$route.query.pid}">
              招生信息
            </div>
            <!--下级菜单链到新闻详情页面-->
            <div class=" sdiv fs16" :id="'sdiv'+index" :class="{dnone:index!=$route.query.pid}">
              <template v-for="(child,index_) in item.children">
                <router-link v-if="child.to=='/enroll/article/list'" :to="{path:child.to,query:{pid:index,id:index_,category_id:child.params.category_id}}" :key="index_+index"
                             class="dblock" :class="{sactive:(index==$route.query.pid && index_==$route.query.id)}">
                  <span class="dnone">→ </span>{{child.name}}
                </router-link>
                <router-link v-else :to="{path:child.to,query:{pid:index,id:index_,article_id:child.params.article_id}}" :key="index_+index"
                             class="dblock" :class="{sactive:(index==$route.query.pid && index_==$route.query.id)}">
                  <span class="dnone">→ </span>{{child.name}}
                </router-link>
              </template>
            </div>
          </template>
          <a v-else-if="item.type==3" :href="item.to" class="sa fs18 dblock" target="_blank">{{item.name}}</a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Left",
  methods:{
    closeDiv(index){
      $('.up-down-div').each(function(){
        if($(this).data('key') == index){
          $(this).next().slideDown();
          $(this).addClass('active');
        }else{
          $(this).next().slideUp();
          $(this).removeClass('active');
        }

      });
    },
    openDiv(){
      $('.up-down-div').each(function(){
        $(this).next().slideUp();
        $(this).removeClass('active');
      });
    },
  },
  mounted() {
    $('.bar-menu2 .hsa.active+div').css('display', 'block');
    $('.up-down-div').click(function(){
      var that = this;
      $(this).toggleClass('active');
      $('.up-down-div').each(function(index){
        if(this!=that){
          $(this).next().slideUp();
        }else{
          $(this).next().slideToggle();
        }
      });

    })
  },
  watch:{
    $route:{
      deep:true,
      immediate:true,
      handler:function(n,o){
        if(n!=undefined && n.hasOwnProperty('query') && n.query.hasOwnProperty('pid')){
          if(n.query.hasOwnProperty('id')){
            this.closeDiv(n.query.pid);
          }else{
            this.closeDiv(0);
          }
        }
        console.log(this.$params['enrollColumn'][n.query.pid]);
      }
    }
  }
}
</script>

<style scoped>
  .sidebar{width: 270px;}
  .sidebar .st{height: 100px;line-height: 100px;}
  .sidebar .adiv{min-height: 415px;background: #f0f0f0;}
  .sidebar .adiv a{padding-left: 80px;height: 55px;line-height: 55px;}
  .sidebar .adiv a:last-child{border-bottom: none;}
  .sidebar .adiv a:hover{background-color: #fefefe;}
  .sidebar .adiv a.active{font-weight: bold;background: url(../../assets/images/cn1.png) no-repeat 27px -1213px;}

  .bar-menu2 .st{height: 68px;line-height: 68px;}
  .bar-menu2 .alist{margin: 0 10px 15px;padding: 10px 8px 8px;background: #fff;}
  .bar-menu2 .ast{margin-bottom: 5px;height: 50px;line-height: 50px;background: #f4f3f3;}
  .bar-menu2 .adiv{min-height: auto;background: #fff;}
  .bar-menu2 .adiv a,.bar-menu2 .adiv .sa{margin-bottom: 5px;padding: 0;height: 45px;line-height: 45px;background: #f4f3f3;}
  .bar-menu2 .adiv .sa.active,.bar-menu2 .adiv .sa:hover:not(.active){background: #94070a;color: #fff;}
  .bar-menu2 .hsa div{display: none;}
  .bar-menu2 .sdiv a:hover{color: #94070a;}
  .bar-menu2 .sactive{background: none;color: #94070a;}
  .bar-menu2 .sactive span{display: inline-block;}
  .bar-menu2 .hsa:active div{display: block;}
  .bar-menu2 .menu{width: 930px;}
</style>



// WEBPACK FOOTER //
// src/components/enroll/Left.vue